module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/75.2ff08b07.png";